import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { observer, inject } from 'mobx-react'
import { Route } from 'react-router-dom'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'

import Invoice from '@root/Invoice'
import Tabs from '@components/Tabs'
import Spinner from '@components/spinner'

import Header from './Header'
import DetailsTab from './ContractDetailsTab'
import ProjectsTab from './ContractProjectsTab'
import FeesTab from './ContractFeesTab'

import ContractStore from './contract.store'

class ContractPage extends Component {
  constructor (props) {
    const { staticData, growlStore } = props

    super(props)

    extendObservable(this, {
      contractStore: new ContractStore(staticData, growlStore)
    })

    this.loadContract()
  }

  loadContract = () => {
    const { match } = this.props
    const { contractStore } = this
    const contractId = Number(match.params.id)

    if (contractStore.contract && contractStore.contract.id === contractId) {
      return
    }
    contractStore
      .get(contractId)
      .then(contractStore.getFeeCount)
  }

  componentDidUpdate () {
    this.loadContract()
  }

  render () {
    const { staticData, match, matchUrl, matchId } = this.props
    const { contractStore } = this
    const { INVOICE_TYPES } = staticData.CONST

    const tabs = generateContractPageTabs(contractStore.isPayg)

    if (contractStore.loading) return <Spinner />

    return (
      <div className='contract-wrapper'>
        <Header contractStore={contractStore} />
        <Tabs
          matchId={matchId}
          matchUrl={matchUrl}
          match={match}
          tabs={tabs}
          ignoreExactMatches={['invoice']}
        />
        <div className='view-wrapper'>
          <Route
            exact
            path={match.url}
            render={() => <DetailsTab contractStore={contractStore} />}
          />
          <Route
            exact
            path={match.url + '/projects'}
            render={() => <ProjectsTab contractStore={contractStore} />}
          />
          <Route
            path={match.url + '/invoice'}
            render={() => (
              <Invoice
                contract={contractStore.contract}
                invoiceType={INVOICE_TYPES.NON_PAYG}
              />
            )}
          />

          <Route
            exact
            path={this.props.match.url + '/consultations'}
            render={() => <FeesTab contractStore={contractStore} />}
          />
        </div>
      </div>
    )
  }

  static propTypes = {
    match: PropTypes.object,
    staticData: PropTypes.object,
    growlStore: PropTypes.object,
    matchId: PropTypes.string,
    matchUrl: PropTypes.string
  }
}

function generateContractPageTabs (isPaygContract) {
  const invoiceTab = {
    tab: 'invoice',
    roles: [
      'FeeManagement',
      'Accounting',
      'AdvancedExpertManagement',
      'ProjectManagement',
      'AdvancedReporting',
      'Admin'
    ]
  }

  const contractTabs = [
    { tab: 'details' },
    { tab: 'projects' },
    { tab: 'consultations' },
    invoiceTab
  ]

  if (isPaygContract) {
    const contractTabsWithoutInvoiceTab = contractTabs.filter(
      tab => tab !== invoiceTab
    )
    return contractTabsWithoutInvoiceTab
  }

  return contractTabs
}

export default withRouter(
  inject('staticData', 'growlStore')(observer(ContractPage))
)
